import type {
  PerfilCompleto,
  Perfil,
  AxiosResponse,
  ListagemPerfil,
} from "../../types";
import { painelApi } from "../painelApi";

const PATH_V1_PERFIS = "/v1/perfis";

export async function recuperarTodosPerfis(): Promise<
  AxiosResponse<ListagemPerfil[]>
> {
  return await painelApi.get(`${PATH_V1_PERFIS}/simples`);
}

export const recuperarTodosPerfisCompletos = async (): Promise<
  AxiosResponse<PerfilCompleto[]>
> => {
  try {
    const response = await painelApi.get(PATH_V1_PERFIS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const recuperarPerfilPorId = async (
  id: string,
): Promise<AxiosResponse<PerfilCompleto>> => {
  try {
    const response = await painelApi.get(`${PATH_V1_PERFIS}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const criarPerfil = async (
  perfil: Partial<Perfil>,
): Promise<AxiosResponse<Perfil>> => {
  try {
    const response = await painelApi.post(PATH_V1_PERFIS, perfil);
    return response;
  } catch (error) {
    throw error;
  }
};

export const editarPerfil = async (
  id: string,
  perfil: Partial<Perfil>,
): Promise<AxiosResponse<Perfil>> => {
  try {
    const response = await painelApi.put(`${PATH_V1_PERFIS}/${id}`, perfil);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deletarPerfilPorId = async (
  id: string,
): Promise<AxiosResponse> => {
  try {
    const response = await painelApi.delete(`${PATH_V1_PERFIS}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
